import { useAuthStore } from "@/stores/authStore"
import { exchangeTokenWithAPI, isTokenExpired, refreshTokenWithAPI } from "@/utils/auth"

export const checkAuthStatus = async (): Promise<boolean> => {
  const store = useAuthStore.getState()
  const { idToken, accessToken, refreshToken } = store.tokens

  if (!idToken) {
    await store.clearAuth()
    return false
  }

  if (!accessToken || isTokenExpired(accessToken)) {
    if (!refreshToken) {
      try {
        const tokens = await exchangeTokenWithAPI(idToken)
        store.setTokens(tokens)
        return true
      } catch {
        await store.clearAuth()
        return false
      }
    }

    try {
      const tokens = await refreshTokenWithAPI({
        accessToken: accessToken!,
        refreshToken,
      })
      store.setTokens(tokens)
      return true
    } catch {
      await store.clearAuth()
      return false
    }
  }

  return true
}
